export type ComparisonRow = {
  feature: string
  values: [string | boolean, string | boolean, string | boolean, string | boolean]
}

/**
 * Values are ordered BASIC, ADVANCED, PREMIUM, CREDIT CONTROL as a SERVICE,
 * matching the plan order in data/pricingPlans.ts.
 */
export const comparisonRows: ComparisonRow[] = [
  { feature: 'Debtor Dashboard', values: [true, true, true, true] },
  { feature: 'Unlimited Users', values: [true, true, true, true] },
  { feature: 'Unlimited Credit Summaries', values: [true, true, true, true] },
  { feature: 'Unlimited Credit Alerts', values: [true, true, true, true] },
  { feature: 'Risk Overview and Analysis', values: [true, true, true, true] },
  { feature: 'Risk Notifications', values: [true, true, true, true] },
  { feature: 'Debtor chasing — email', values: [true, true, true, true] },
  { feature: 'Selective Invoice Financing', values: [true, true, true, true] },
  { feature: 'Customer Service and Support', values: [true, true, true, true] },
  { feature: 'Personalised Email Templates', values: [true, true, true, true] },
  {
    feature: 'Invoice Chasing Per Month',
    values: ['Unlimited', 'Unlimited', 'Unlimited', 'Unlimited'],
  },
  {
    feature: 'Copy Overdue Invoices into email Chasing',
    values: [true, true, true, true],
  },
  {
    feature: 'Email Chasing by Credit Manager',
    values: [false, false, true, true],
  },
  {
    feature: 'Premium Credit Reports Per Year',
    values: ['25', '25', '100', 'Unlimited'],
  },
  {
    feature: 'New Monthly Invoices',
    values: ['Unlimited', 'Unlimited', 'Unlimited', 'Unlimited'],
  },
  {
    feature: 'Domain Used for email Chasing',
    values: ['Satago Email', 'Your Email', 'Your/Our Email', 'POA'],
  },
  {
    feature: 'NO WIN NO FEE Debt Collection Service',
    values: ['10%', '10%', '10%', 'POA'],
  },
  {
    feature: 'Debt Collection Legal Service',
    values: ['POA', 'POA', 'POA', 'POA'],
  },
]
